import { CardFaceData, CardFacePreviewImage } from '../../../global-types';

/**
 * Derives the user-facing label for a card face in the same way the legacy
 * `CardSelectBar` did: take the face `type`, replace dashes with spaces, and
 * pluralize the special-case "Envelope" face when the card is one-to-many.
 */
export const getCardFaceLabel = (face: CardFaceData | CardFacePreviewImage, isOneToMany: boolean): string => {
  const type = face?.type ?? '';
  if (type === 'Envelope' && isOneToMany) {
    return `${type.replaceAll('-', ' ')}s`;
  }
  return type.replaceAll('-', ' ');
};
